'use strict';

const { queryFirst, queryAll, addClass, hasClass, removeClass, matchesBreakpoint } = require('../domUtil');

const breakpoints = require('../breakpoints');

const { updatePLPTileHeight } = require('../product/helper');

let windowWidth = window.innerWidth;
const hideClass = 'hidden-filters';
const hideEle = 'd-none';
const hideBtn = queryFirst('.hide-filter-btn');
const hideFilterEle = queryFirst('.hide-filter');
const openFilterIcon = queryFirst('.open_filter_icon');
const closeFilterIcon = queryFirst('.close_filter_icon');
const refinementBar = queryFirst('.refinement-bar');
const searchContainerEl = queryFirst('.search-results-container');
const refinementsEl = queryFirst('.refinements');
const refinementBarTitleEl = queryFirst('h5 .title', refinementsEl);
const sortOrderBtn = queryFirst('.sort-order-menu-toggle');
const lastAccordionElement = queryFirst('.accordion-container:last-child', refinementsEl);
const firstAccordionElement = queryFirst('.accordion-container:first-child .title', refinementsEl);
const lastTitleBtnEl = queryFirst('.title', lastAccordionElement);
let lastSubBtnEls = queryAll('button:not([disabled]), input:not([disabled]), [href]:not(.d-md-none), [tabindex]:not([tabindex="-1"])', lastAccordionElement);
let lastSubBtnEl;
if ((lastSubBtnEls || []).length) {
    lastSubBtnEl = lastSubBtnEls[lastSubBtnEls.length - 1];
}

if (refinementBar && !hasClass(queryFirst('.no-filter-results'), 'd-none')) {
    refinementBar.style.setProperty('display', 'none', 'important');
}

const filterPill = queryFirst('.toggle-grid .filter-value:first-child button');
const KEYCODE_TAB = 9;
const mql = window.matchMedia('(max-width: 767px)');
const firstAddToWishlistBtn = queryFirst('.product-tile-container .add-to-wish-list');

const toggleFilterDisplay = () => {
    if (windowWidth < breakpoints.md) {
        return;
    }

    if (searchContainerEl && hasClass(searchContainerEl, hideClass)) {
        removeClass(searchContainerEl, hideClass);
        addClass(closeFilterIcon, hideEle);
        removeClass(openFilterIcon, hideEle);
        hideBtn.textContent = 'Filter';
        hideBtn.setAttribute('aria-expanded', 'true');
        refinementBar.removeAttribute('tabindex');
        refinementBar.style.setProperty('display', 'flex', 'important');
        $(hideBtn).trigger('toggle.lp.filters', 'filter menu: show');
        if (!matchesBreakpoint('lg')) {
            setTimeout(() => {
                refinementBarTitleEl.focus();
                updatePLPTileHeight('Filter');
            }, 500);
        }
        return;
    }

    addClass(searchContainerEl, hideClass);
    addClass(openFilterIcon, hideEle);
    removeClass(closeFilterIcon, hideEle);
    if (hasClass(openFilterIcon, hideEle) && !hasClass(queryFirst('.no-filter-results'), 'd-none')) {
        refinementBar.style.setProperty('display', 'none', 'important');
    }
    hideBtn.textContent = 'Filter';
    hideBtn.setAttribute('aria-expanded', 'false');
    searchContainerEl.setAttribute('tabindex', '-1');
    $(hideBtn).trigger('toggle.lp.filters', 'filter menu: hide');
    if (!matchesBreakpoint('lg')) {
        setTimeout(() => {
            updatePLPTileHeight('Filter');
        }, 500);
    }
    hideBtn.focus();
};

if (window.location.search.includes('storeID')) {
    toggleFilterDisplay();
    const showFilterSortHeader = queryFirst('.show-filter-sort-header');
    const displayClass = 'd-md-flex';

    addClass(showFilterSortHeader, displayClass);
    removeClass(showFilterSortHeader, 'd-none');
}

const handleSortOrderTab = e => {
    const lastElExpanded = lastTitleBtnEl.getAttribute('aria-expanded');
    const sortOrderExpanded = sortOrderBtn.getAttribute('aria-expanded');
    const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
    if (!isTabPressed) {
        return;
    }

    if (e.shiftKey) {
        /* shift + tab */
        if (searchContainerEl && hasClass(searchContainerEl, hideClass)) {
            hideBtn.focus();
        } else if (lastElExpanded === 'false') {
            lastTitleBtnEl.focus();
        } else if (lastSubBtnEl) {
            lastSubBtnEl.focus();
        }
        e.preventDefault();
    } else if (sortOrderExpanded === 'true') {
        queryFirst('.sort-order-menu-option:first-child').focus();
    } else if (filterPill) {
        filterPill.focus();
    } else {
        const hiddenFilterPill = hasClass(queryFirst('.product-grid-container .filter-bar .row'), 'd-md-none');
        const filterPill = queryFirst('.product-grid-container .filter-value:first-child button');
        if (!hiddenFilterPill && filterPill) {
            filterPill.focus();
        } else if (firstAddToWishlistBtn) {
            firstAddToWishlistBtn.focus();
        }
    }
    e.preventDefault();
};

const handleFilterTab = e => {
    const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
    if (!isTabPressed) {
        return;
    }

    if (!e.shiftKey) {
        if (!(searchContainerEl && hasClass(searchContainerEl, hideClass))) {
            refinementBarTitleEl.focus();
        } else {
            sortOrderBtn.focus();
        }
        e.preventDefault();
    }
};

const handleLastElTab = e => {
    const lastElExpanded = lastTitleBtnEl.getAttribute('aria-expanded');
    const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
    if (!isTabPressed) {
        return;
    }

    if (lastElExpanded === 'false' && !e.shiftKey) {
        sortOrderBtn.focus();
        e.preventDefault();
    } else if (lastElExpanded === 'true' && !e.shiftKey) {
        queryFirst('ul li:first-child button', lastAccordionElement).focus();
        e.preventDefault();
    }
};

const handleFirstElTab = e => {
    const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
    if (!isTabPressed) {
        return;
    }
    if (e.shiftKey) {
        hideBtn.focus();
        e.preventDefault();
    }
};

const handleLastSubBtnElTab = e => {
    if (e.target.closest('form[name=price-filter-form]')) {
        lastSubBtnEls = queryAll('button:not([disabled]), input:not([disabled]), [href]:not(.d-md-none), [tabindex]:not([tabindex="-1"])', lastAccordionElement);
        lastSubBtnEl.removeEventListener('keydown', handleLastSubBtnElTab);
        if ((lastSubBtnEls || []).length) {
            lastSubBtnEl = lastSubBtnEls[lastSubBtnEls.length - 1];
            lastSubBtnEl.addEventListener('keydown', handleLastSubBtnElTab);
        }
    }
    const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
    if (!isTabPressed) {
        return;
    }

    if (!e.shiftKey) {
        sortOrderBtn.focus();
        e.preventDefault();
    }
};

const handleWishlistBtnTab = e => {
    const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
    if (!isTabPressed) {
        return;
    }
    if (e.shiftKey) {
        sortOrderBtn.focus();
        e.preventDefault();
    }
};

const handleFilterPillBtnTab = e => {
    const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
    if (!isTabPressed) {
        return;
    }
    if (e.shiftKey) {
        sortOrderBtn.focus();
        e.preventDefault();
    }
};

const mobileScrollToBottom = () => {
    if (lastAccordionElement) {
        const target = queryFirst('.title', lastAccordionElement).dataset.target;
        $(target).on('shown.bs.collapse', function () {
            queryFirst('.refinement-price').scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    }
};

const windowTest = w => {
    if (w.matches) {
        mobileScrollToBottom();
    }
};

const handleSlotsAppearance = () => {
    const categoryMarketingSlots = queryAll('.category-marketing-slot', searchContainerEl);
    if (categoryMarketingSlots) {
        categoryMarketingSlots.forEach(categoryMarketingSlot => {
            if (categoryMarketingSlot && categoryMarketingSlot.children.length === 0) {
                categoryMarketingSlot.remove();
            } else {
                removeClass(categoryMarketingSlot, hideEle);
            }
        });
    }
};

module.exports = () => {
    $('.carousel').carousel();
    $('body').on('search:updateProducts', function () {
        $('.carousel').carousel();
    });
    if (hideBtn && hideFilterEle) {
        hideFilterEle.addEventListener('click', toggleFilterDisplay);
        hideFilterEle.addEventListener('keydown', handleFilterTab);
    }
    if (sortOrderBtn) {
        sortOrderBtn.addEventListener('keydown', handleSortOrderTab);
    }
    if (lastTitleBtnEl) {
        lastTitleBtnEl.addEventListener('keydown', handleLastElTab);
        if (lastSubBtnEl) {
            lastSubBtnEl.addEventListener('keydown', handleLastSubBtnElTab);
        }
    }
    if (firstAccordionElement) {
        firstAccordionElement.addEventListener('keydown', handleFirstElTab);
    }
    if (firstAddToWishlistBtn) {
        firstAddToWishlistBtn.addEventListener('keydown', handleWishlistBtnTab);
    }
    if (filterPill) {
        filterPill.addEventListener('keydown', handleFilterPillBtnTab);
    }

    handleSlotsAppearance();

    $('body').on('search:updateProducts', function () {
        if (lastAccordionElement) {
            windowTest(mql);
        }

        handleSlotsAppearance();
    });

    if (lastAccordionElement) {
        windowTest(mql);
    }
};
